import { 
	useEffect,
	useRef,
	type CSSProperties,
	type FunctionComponent,
	type PropsWithChildren,
} from "react";


export declare type PanelProps = PropsWithChildren<{
	className?: string;
	height?: string;
	style?: CSSProperties;
	width?: string;
}>;


export const Panel: FunctionComponent<PanelProps> = ({
	className = "",
	width = "auto",
	height = "auto",
	style = {},
	children,
}) => {

	// const view = useRef(null);
	const classes = () => [ "panel", ...className.split(" "), ].join(" ");

	// useEffect(() => {
	// 	if(view.current) {

	// 	}
	// }, []);

	return (
		<div className={classes()} style={style}>
			<div className="view">
				{children}
			</div>
		</div>
	);

}
